import React, {useState} from "react";
import {sub} from "date-fns";

const AppContext = React.createContext({
    isLoggedIn: null,
    setLoggedIn: () => {},
    doLogout: () => {},
    startDate: null,
    endDate: null
})

export const AppContextProvider = (props) => {
    const [isLoggedIn, setIsLoggedIn] = useState(
        localStorage.getItem('token')
    );

    const setLoggedIn = (val) => {
        setIsLoggedIn(val)
    }
    const doLogout = () => {
        localStorage.clear();
        setIsLoggedIn(false);
    }

    return(
        <AppContext.Provider value={{
            isLoggedIn,
            setLoggedIn,
            doLogout,
            startDate: sub(new Date("2023-11-30"), {days: 5}),
            endDate: new Date("2023-11-30")
        }}>
            {props.children}
        </AppContext.Provider>
    )
}

export default AppContext;
